export default __webpack_public_path__ + "static/media/default-background.7db49c0d.svg";